import { render, staticRenderFns } from "./CountCatalogPagesButton.vue?vue&type=template&id=5af3f87f"
import script from "./CountCatalogPagesButton.vue?vue&type=script&lang=ts"
export * from "./CountCatalogPagesButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports